import React, { FC, ReactNode } from 'react';
import { FormControl, FormErrorMessage, FormLabel, Icon, Input, InputGroup, InputLeftElement, InputRightElement, Textarea } from '@chakra-ui/react';
import { IconType } from 'react-icons/lib';

import { eventValue } from '@app/utils/event-value';

import { FieldComponentProps } from './types';

type TextFieldProps = FieldComponentProps<string> & {
  multiline?: boolean;
  rows?: number;
  variant?: 'outlined' | 'standard' | 'filled';
  leftIcon?: IconType;
  rightElement?: ReactNode;
  max?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

export const TextField: FC<TextFieldProps> = (props) => {
  const { 
    onChange, 
    helperText, 
    error, 
    value, 
    label, 
    multiline,
    required,
    id,
    disabled,
    leftIcon, 
    rightElement,
    max,
    onKeyDown,
    readOnly = false,
  } = props;
  return (<InputGroup>
    <FormControl 
      variant="floating" 
      id={id} 
      isRequired={required}
      isInvalid={error}
      isDisabled={disabled}
    >
      {leftIcon && <InputLeftElement pointerEvents='none'>
        <Icon as={leftIcon} color='brand.300' />
      </InputLeftElement>}
      {rightElement && <InputRightElement>
        {rightElement}
      </InputRightElement>}
      {!multiline && <Input 
        placeholder={label}
        value={value}
        maxLength={max}
        onChange={eventValue(onChange)}
        onKeyDown={onKeyDown}
        readOnly={readOnly}
      />}
      {multiline && <Textarea
        value={value}
        onChange={eventValue(onChange)}
        placeholder={label}
        maxLength={max}
        size='sm'
        onKeyDown={onKeyDown}
        readOnly={readOnly}
      />}
      <FormLabel textColor="dark.300">{label}</FormLabel>
      {error && <FormErrorMessage>{helperText}</FormErrorMessage>}
    </FormControl>
  </InputGroup>);
};

export default TextField;
